import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const IMG =
  "https://static.prod-images.emergentagent.com/jobs/51ddf5f6-e80c-4259-9ef6-c5393e7b5903/images/db6a4cdca2b1655caa2657ceea8b35c9a1eacadba1089b77d7616aa2935bd06b.png";

const CITIES = [
  "Cape Coral",
  "Fort Myers",
  "Naples",
  "Bonita Springs",
  "Estero",
  "Lee County",
  "Collier County",
];

export default function ServiceArea() {
  return (
    <section
      data-testid="service-area-section"
      aria-labelledby="service-area-heading"
      className="relative overflow-hidden bg-white py-20 sm:py-24"
    >
      <div className="container-page grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-14">
        <motion.div
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="lg:col-span-6"
        >
          <span className="pill">
            <MapPin className="h-3 w-3 text-aqua" />
            Coverage
          </span>
          <h2
            id="service-area-heading"
            className="mt-4 font-display text-3xl font-bold leading-tight tracking-tight text-navy sm:text-4xl lg:text-[2.5rem]"
          >
            Serving Southwest Florida.
          </h2>
          <p className="mt-4 max-w-xl text-base text-navy/70 sm:text-lg">
            From Cape Coral down through Collier County &mdash; the coast,
            the canals, and the neighborhoods where Florida humidity hits
            hardest.
          </p>

          <ul className="mt-7 flex flex-wrap gap-2.5">
            {CITIES.map((city) => (
              <li key={city}>
                <Link
                  to="/service-areas"
                  data-testid={`service-area-pill-${city.toLowerCase().replace(/\s+/g, "-")}`}
                  className="group inline-flex items-center gap-1.5 rounded-full border border-mist-line bg-white px-3.5 py-2 text-sm font-medium text-navy/85 shadow-soft transition-colors hover:border-aqua/45 hover:bg-aqua/[0.06] hover:text-navy"
                >
                  <span className="h-1.5 w-1.5 rounded-full bg-aqua transition-transform group-hover:scale-125" />
                  {city}
                </Link>
              </li>
            ))}
          </ul>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.55, ease: "easeOut" }}
          className="lg:col-span-6"
        >
          <div className="relative overflow-hidden rounded-3xl border border-mist-line bg-mist shadow-lift">
            <img
              src={IMG}
              alt="Stylized map of the Southwest Florida coastline highlighting Sun Chaser Cooling service areas."
              className="h-full w-full object-cover"
              loading="lazy"
            />
            <div
              className="pointer-events-none absolute inset-0 bg-gradient-to-tr from-navy/40 via-transparent to-transparent"
              aria-hidden="true"
            />
            <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between rounded-2xl border border-white/15 bg-navy/85 p-3 text-white backdrop-blur">
              <div className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-aqua" />
                <p className="text-sm font-semibold">SWFL coastal coverage</p>
              </div>
              <span className="text-[11px] uppercase tracking-[0.16em] text-white/65">
                Demo map · illustrative
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
